import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import {
  FetchGraphByExpectedGen,
  FetchGraphByInvesterguaranteeNew,
  FetchGraphByminimumguaranteeNew,
  FetchGraphBysortNew,
  fetchGraphV2Data,
} from '../../../../services/api'
import dayjs from 'dayjs'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { saveAs } from 'file-saver'
import { selectJwtToken } from '../../../../redux/selectors/authSelector'
import { useSelector } from 'react-redux'
import useInvestorGuaranteedgraphStyles from './styles'
import { Grid } from '@mui/material'

const InvestorGuaranteedgraph = ({ state, plantContent }) => {
  const classes = useInvestorGuaranteedgraphStyles()

  const [technicalFromDate, setTechnicalFromDate] = React.useState(
    dayjs(new Date()).subtract(29, 'day')
  )
  const [technicalToDate, setTechnicalToDate] = React.useState(
    dayjs(new Date())
  )
  const [mapinverterData, setMapinverterData] = React.useState([])
  const [mapInverterSeries, setMapInverterSeries] = React.useState([])
  const [inverterviewbutton, setinverterviewbutton] = useState('1m')
  const [graphType, setGraphType] = useState('etoday')
  const [selectedDeviceID, setSelectedDeviceID] = useState(1)
  const [selectedTypeID, setSelectedTypeID] = useState(1)
  const [selectedButtons, setSelectedButtons] = useState([])
  const [open, setOpen] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [datepickerDisable, setDatepickerDisable] = React.useState(false)

  const PlantID = state?.id

  const token = useSelector(selectJwtToken) // Access the token from the Redux store

  const isButtonSelected = (buttonName) => selectedButtons.includes(buttonName)

  // Update screen size when the component mounts and when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight)
    }
    // Attach the resize event listener
    window.addEventListener('resize', handleResize)
    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const [lineData, setLineData] = useState({
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false,
        },
        toolbar: {
          export: {
            csv: {
              filename: 'EnergyAnalysis',
              columnDelimiter: ',',
              headerCategory: 'Date',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString()
              },
            },
            svg: {
              filename: 'EnergyAnalysis',
            },
            png: {
              filename: 'EnergyAnalysis',
            },
          },
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
      },
      title: {
        align: 'left',
      },
      colors: [
        '#6CB759',
        '#5968B7',
        '#dc3545',
        '#F5B041',
        '#BB8FCE',
        '#CCCCFF',
      ],
      markers: {
        size: 2,
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        type: 'category',
        floating: false,
        tickAmount: 15,
        tickPlacement: 'on',
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: true,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          },
          offsetX: 0,
          offsetY: 0,
          format: 'dd/MM',
          formatter: function (value, timestamp, opts) {
            return dayjs(value).format('DD-MM')
          },
          datetimeUTC: false,
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm',
          },
        },
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          format: 'dd MMM',
          formatter: function (value, opts) {
            return dayjs(
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
                ?.x
            ).format('DD-MM-YYYY')
          },
        },
      },
    },
  })

  const DEVID = state?.roofDetails?.[0]?.inverters?.[0]?.id

  useEffect(() => {
    setSelectedDeviceID(DEVID)
    setSelectedButtons([`ActualGeneration`])
  }, [DEVID])

  useEffect(() => {
    // Pass dayjs objects directly, not formatted strings
    handleChangePreiod(inverterviewbutton, technicalFromDate, technicalToDate)
  }, [technicalFromDate, technicalToDate])
  useEffect(() => {
    handleSelectInverter(
      graphType,
      inverterviewbutton,
      selectedDeviceID,
      selectedTypeID,
      technicalFromDate,
      technicalToDate
    )
  }, [])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSelectInverter = (
    type,
    duration,
    deviceID,
    typeID,
    selectedDate,
    selectedtoDate
  ) => {
    let subtraction
    let subType
    let graphName
    let TechnicalDate
    let TechnicalTodate
    switch (duration) {
      case 'year':
        subtraction = 1
        subType = 'year'
        TechnicalDate = selectedDate
        TechnicalTodate = 'all'
        break
      case '1m':
        subtraction = 0
        subType = 'month'
        TechnicalDate = selectedDate
        TechnicalTodate = 'all'
        break
      case '3m':
        subtraction = 3
        subType = 'month'
        TechnicalDate = selectedDate
        TechnicalTodate = 'all'
        break
      case '6m':
        subtraction = 6
        subType = 'month'
        TechnicalDate = selectedDate
        TechnicalTodate = 'all'
        break
      case 'mtd':
        subtraction = 0
        subType = 'month'
        TechnicalDate = dayjs(new Date())
        TechnicalTodate = 'all'
        break
      case 'ytd':
        subtraction = 0
        subType = 'month'
        TechnicalDate = dayjs(new Date())
        TechnicalTodate = 'all'
        break
      case 'custom':
        subtraction = 0
        subType = 'month'
        TechnicalDate = selectedDate
        TechnicalTodate = selectedtoDate || technicalToDate
        break
      default:
        // Handle the default case here if needed
        break
    }
  
    if (duration !== 'custom') {
      TechnicalDate = dayjs()
      TechnicalTodate = 'all'
    }

    const sortDate = dayjs(TechnicalDate).format('DD-MM-YYYY')

    if (type === 'InvestorGuaranteedGeneration') {
      FetchGraphByInvesterguaranteeNew(
        PlantID,
        sortDate,
        token,
        duration,
        TechnicalTodate
      ).then((resp) => {
        if (resp?.data) {
          const newEnergyData = resp?.data.map((obj) => ({
            x: obj.x,
            y: Number(parseFloat(obj.y).toFixed(1)),
          }))

          let devtype
          if (type === 'etoday') {
            devtype = 'ActualGeneration'
          } else if (type === 'InvestorGuaranteedGeneration') {
            devtype = 'InvestorGuaranteedGeneration'
          } else if (type === 'ExpectedGeneration') {
            devtype = 'ExpectedGeneration'
          }

          setMapInverterSeries((prevSeries) => {
            const existingObject = prevSeries.find(
              (obj) => obj.name === `${devtype}`
            )

            if (existingObject) {
              const updatedObject = {
                ...existingObject,
                data: newEnergyData,
              }

              return prevSeries.map((obj) =>
                obj.name === `${devtype}` ? updatedObject : obj
              )
            } else {
              const newObject = {
                name: `${devtype}`,
                data: newEnergyData,
              }

              return [...prevSeries, newObject]
            }
          })
        } else {
        }
      })
    } else if (type === 'ExpectedGeneration') {
      FetchGraphByExpectedGen(PlantID, sortDate, token, duration).then(
        (resp) => {
          if (resp?.data) {
            const newEnergyData = resp?.data.map((obj) => ({
              x: obj.x,
              y: Number(parseFloat(obj.y).toFixed(1)),
            }))

            let devtype
            if (type === 'etoday') {
              devtype = 'ActualGeneration'
            } else if (type === 'InvestorGuaranteedGeneration') {
              devtype = 'InvestorGuaranteedGeneration'
            } else if (type === 'ExpectedGeneration') {
              devtype = 'ExpectedGeneration'
            }
            setMapInverterSeries((prevSeries) => {
              const existingObject = prevSeries.find(
                (obj) => obj.name === `${devtype}`
              )

              if (existingObject) {
                const updatedObject = {
                  ...existingObject,
                  data: newEnergyData,
                }

                return prevSeries.map((obj) =>
                  obj.name === `${devtype}` ? updatedObject : obj
                )
              } else {
                const newObject = {
                  name: `${devtype}`,
                  data: newEnergyData,
                }

                return [...prevSeries, newObject]
              }
            })
          } else {
          }
        }
      )
    } else if (type === 'ForecastedGeneration') {
      FetchGraphByminimumguaranteeNew(
        PlantID,
        sortDate,
        token,
        duration,
        TechnicalTodate
      ).then((resp) => {
        if (resp?.data) {
          const newInverterData = resp?.data.map((obj) => ({
            x: obj.x,
            y: Number(parseFloat(obj.y).toFixed(1)),
          }))
          let devtype
          if (type === 'etoday') {
            devtype = 'ActualGeneration'
          } else if (type === 'InvestorGuaranteedGeneration') {
            devtype = 'InvestorGuaranteedGeneration'
          } else if (type === 'ExpectedGeneration') {
            devtype = 'ExpectedGeneration'
          } else if (type === 'ForecastedGeneration') {
            devtype = 'ForecastedGeneration'
          }

          setMapinverterData(newInverterData)
          setMapInverterSeries((prevSeries) => {
            const existingObject = prevSeries.find(
              (obj) => obj.name === `${devtype}`
            )

            if (existingObject) {
              const updatedObject = {
                ...existingObject,
                data: newInverterData,
              }

              return prevSeries.map((obj) =>
                obj.name === `${devtype}` ? updatedObject : obj
              )
            } else {
              const newObject = {
                name: `${devtype}`,
                data: newInverterData,
              }

              return [...prevSeries, newObject]
            }
          })
        } else {
        }
      })
    } else {
      //using graph-v2 api
      if (type === 'etoday') {
        
        const formattedFromDate = dayjs(TechnicalDate).isValid() 
          ? dayjs(TechnicalDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD')
        
        const formattedToDate = TechnicalTodate === 'all' 
          ? 'all' 
          : dayjs(TechnicalTodate).isValid()
          ? dayjs(TechnicalTodate).format('YYYY-MM-DD')
          : 'all'

        fetchGraphV2Data(
          PlantID,
          'inverter', //using ivnerter instead of etoday - change later
          formattedFromDate,
          duration,
          token,
          'all',
          formattedToDate,
          'all'
        ).then((resp) => {
          if (resp && Array.isArray(resp)) {
            const newInverterData = resp.map((obj) => ({
              x: obj.x,
              y: Number(parseFloat(obj.y || 0).toFixed(1)),
            }))

            const devtype = 'ActualGeneration'

            setMapinverterData(newInverterData)
            setMapInverterSeries((prevSeries) => {
              const existingObject = prevSeries.find(
                (obj) => obj.name === devtype
              )

              if (existingObject) {
                const updatedObject = {
                  ...existingObject,
                  data: newInverterData,
                }

                return prevSeries.map((obj) =>
                  obj.name === devtype ? updatedObject : obj
                )
              } else {
                const newObject = {
                  name: devtype,
                  data: newInverterData,
                }

                return [...prevSeries, newObject]
              }
            })
          } else {
            console.error('Invalid response from Graph V2 API:', resp)
          }
        }).catch((error) => {
          console.error('Error fetching Graph V2 data:', error)
        })
      } else {
        //Use old API for other types - format as DD-MM-YYYY for old API
        const sortDate = dayjs(TechnicalDate).format('DD-MM-YYYY')
        
        FetchGraphBysortNew(
          PlantID,
          sortDate,
          duration,
          type,
          token,
          TechnicalTodate,
          'all',
          'all'
        ).then((resp) => {
          if (resp?.data) {
            const newInverterData = resp?.data.map((obj) => ({
              x: obj.x,
              y: Number(parseFloat(obj.y).toFixed(1)),
            }))
            let devtype
            if (type === 'etoday') {
              devtype = 'ActualGeneration'
            } else if (type === 'InvestorGuaranteedGeneration') {
              devtype = 'InvestorGuaranteedGeneration'
            } else if (type === 'ExpectedGeneration') {
              devtype = 'ExpectedGeneration'
            }

            setMapinverterData(newInverterData)
            setMapInverterSeries((prevSeries) => {
              const existingObject = prevSeries.find(
                (obj) => obj.name === `${devtype}`
              )

              if (existingObject) {
                const updatedObject = {
                  ...existingObject,
                  data: newInverterData,
                }

                return prevSeries.map((obj) =>
                  obj.name === `${devtype}` ? updatedObject : obj
                )
              } else {
                const newObject = {
                  name: `${devtype}`,
                  data: newInverterData,
                }

                return [...prevSeries, newObject]
              }
            })
          } else {
          }
        })
      }
    }
  }

  const separateValues = (str) => {
    const [label, value] = str.split(' ') // Split the string into two parts using the space as a separator
    return { label, value }
  }

  const handleChangePreiod = (Period, selectedDate, selectedtoDate) => {
    selectedButtons.map((item) => {
      const { label, value } = separateValues(item)

      let devtype
      if (label === 'ActualGeneration') {
        devtype = 'etoday'
      } else if (label === 'InvestorGuaranteedGeneration') {
        devtype = 'InvestorGuaranteedGeneration'
      } else if (label === 'ExpectedGeneration') {
        devtype = 'ExpectedGeneration'
      } else if (label === 'ForecastedGeneration') {
        devtype = 'ForecastedGeneration'
      }

      handleSelectInverter(
        devtype,
        Period,
        selectedDeviceID,
        selectedTypeID,
        selectedDate,
        selectedtoDate
      )
    })
  }

  const handleChooseDate = (value, type) => {
    let subtraction
    let subType

    switch (inverterviewbutton) {
      case 'year':
        subtraction = 11
        subType = 'month'
        break
      case '1m':
        subtraction = 29
        subType = 'day'
        break
      case '3m':
        subtraction = 3
        subType = 'month'
        break
      case '6m':
        subtraction = 6
        subType = 'month'
        break
      case 'mtd':
        subtraction = 0
        subType = 'month'
        break
      case 'ytd':
        subtraction = 0
        subType = 'month'
        break
      case 'custom':
        subtraction = 0
        subType = 'month'
        break
      default:
        // Handle the default case here if needed
        break
    }

    if (type === 'from') {
      if (inverterviewbutton === 'custom') {
        setTechnicalFromDate(value)
      } else {
        const yearData = dayjs(value).add(subtraction, subType)
        setTechnicalFromDate(value)
        const currentDate1y = dayjs()
        const isFuture1y = yearData.isAfter(currentDate1y)
        if (isFuture1y) {
          const previous1yData = dayjs(dayjs(new Date())).subtract(
            subtraction,
            subType
          )
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
        } else {
          setTechnicalToDate(dayjs(new Date()))
        }
      }
    } else if (type === 'to') {
      if (inverterviewbutton === 'custom') {
        setTechnicalToDate(value)
      } else {
        const yearData = dayjs(value).subtract(subtraction, subType)
        setTechnicalFromDate(yearData)
        setTechnicalToDate(dayjs(new Date()))
      }
    }
  }

  const handleselectButton = (ButtonType) => {
    switch (ButtonType) {
      case 'year':
        const yearData = dayjs(technicalFromDate).add(11, 'month')
        const currentDate1y = dayjs()
        const isFuture1y = yearData.isAfter(currentDate1y)
        if (isFuture1y) {
          const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('year')
          handleChangePreiod('year', previous1yData)
        } else {
          const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('year')
          handleChangePreiod('year', previous1yData)
        }

        break
      case '1m':
        const monthData = dayjs(technicalFromDate).add(29, 'day')
        const currentDate1 = dayjs()
        const isFuture1 = monthData.isAfter(currentDate1)
        if (isFuture1) {
          const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
          setTechnicalFromDate(previous1Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('1m')
          handleChangePreiod('1m', previous1Data)
        } else {
          const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
          setTechnicalFromDate(previous1Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('1m')
          handleChangePreiod('1m', previous1Data)
        }
        break
      case '3m':
        const month3Data = dayjs(technicalFromDate).add(3, 'month')
        const currentDate = dayjs()
        const isFuture = month3Data.isAfter(currentDate)
        if (isFuture) {
          const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
          setTechnicalFromDate(previous3Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('3m')
          handleChangePreiod('3m', previous3Data)
        } else {
          const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
          setTechnicalFromDate(previous3Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('3m')
          handleChangePreiod('3m', previous3Data)
        }
        break
      case '6m':
        const month6Data = dayjs(technicalFromDate).add(6, 'month')
        const currentDate6 = dayjs()
        const isFuture6 = month6Data.isAfter(currentDate6)
        if (isFuture6) {
          const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
          setTechnicalFromDate(previous6Data)
          setTechnicalToDate(dayjs(new Date()))
          handleChangePreiod('6m', previous6Data)
          setinverterviewbutton('6m')
        } else {
          const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
          setTechnicalFromDate(previous6Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('6m')
          handleChangePreiod('6m', previous6Data)
        }
        break
      case 'mtd':
        const firstDateOfMonth = dayjs(new Date()).startOf('month')
        const mtdData = dayjs(new Date()).subtract(1, 'month')
        setTechnicalFromDate(firstDateOfMonth)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('mtd')
        handleChangePreiod('mtd', dayjs(new Date()))

        break
      case 'ytd':
        const firstDateOfYear = dayjs(new Date()).startOf('year')
        const ytdData = dayjs(new Date()).subtract(1, 'year')
        setTechnicalFromDate(firstDateOfYear)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('ytd')
        handleChangePreiod('ytd', dayjs(new Date()))

        break
      case 'custom':
        // Pass dayjs objects directly, not formatted strings
        setinverterviewbutton('custom')
        handleChangePreiod('custom', technicalFromDate, technicalToDate)

        break
      default:
        break
    }
  }

  const handleInverterViewSort = (type) => {
    if (type === 'year') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })
      handleselectButton('year')
    } else if (type === '1m') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('1m')
    } else if (type === '3m') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MMM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('3m')
    } else if (type === '6m') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MMM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('6m')
    } else if (type === 'ytd') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MMM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })
      handleselectButton('ytd')
    } else if (type === 'mtd') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('DD-MMM')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MMMM-YYYY')
              },
            },
          },
        },
      })
      handleselectButton('mtd')
    } else if (type === 'custom') {
      setDatepickerDisable(false)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MMM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('custom')
    }
  }

  const handleButtonClick = (buttonName, deviceID, typeID) => {
    if (selectedButtons.includes(`${buttonName}`)) {
      setSelectedButtons(
        selectedButtons.filter((btn) => btn !== `${buttonName}`)
      )

      setMapInverterSeries(
        (prevSeries) => prevSeries.filter((obj) => obj.name !== `${buttonName}`) // Specify the name of the object to remove
      )
    } else {
      setSelectedButtons([...selectedButtons, `${buttonName}`])
      setSelectedDeviceID(deviceID)
      setSelectedTypeID(typeID)
      let devtype
      if (buttonName === 'ActualGeneration') {
        devtype = 'etoday'
      } else if (buttonName === 'InvestorGuaranteedGeneration') {
        devtype = 'InvestorGuaranteedGeneration'
      } else if (buttonName === 'ExpectedGeneration') {
        devtype = 'ExpectedGeneration'
      } else if (buttonName === 'ForecastedGeneration') {
        devtype = 'ForecastedGeneration'
      }

      setGraphType(devtype)
      handleSelectInverter(
        devtype,
        inverterviewbutton,
        deviceID,
        typeID,
        technicalFromDate,
        technicalToDate
      )
    }
  }

  const columns = [
    { field: 'x', headerName: 'Date', width: 100 },
    { field: 'y', headerName: 'Yield', width: 100 },
  ]

  const exportToCSV = (rows) => {
    const headings = ['Date', ...rows.map((item) => item.name)] // Add 'Date' and 'name' properties as headings
    const csvContent = [headings.join(',')]

    const allDates = new Set()
    rows.forEach((item) =>
      item.data.forEach((row) =>
        allDates.add(dayjs(row.x).format('DD-MM-YYYY'))
      )
    )

    allDates.forEach((date) => {
      const rowData = [date]
      rows.forEach((item) => {
        const dataForDate = item.data.find(
          (row) => dayjs(row.x).format('DD-MM-YYYY') === date
        )
        rowData.push(dataForDate ? dataForDate.y : 0)
      })
      csvContent.push(rowData.join(','))
    })

    const blob = new Blob([csvContent.join('\n')], {
      type: 'text/csv;charset=utf-8',
    })
    saveAs(blob, 'EnergyAnalysis.csv')
  }
  const datePickerStyle = {
    width: '130px',
  }

  const dynamicHeadings = mapInverterSeries.map((item) => item.name)
  return (
    <div className={classes.root}>
      <div
        className="graph_bg mb_10"
        style={{ minHeight: '510px', backgroundColor: 'white' }}
      >
        <div className="align_btw mb_6">
          <div>
            <div className="h_txt1">
              Performance against Investor Guarantee Graph
            </div>
          </div>

          <div>
            <div className="align_end">
              <div class="check_graph mr_8">
                <input
                  id="check9"
                  type="checkbox"
                  checked={openTable}
                  onChange={(e) => setOpenTable(!openTable)}
                />
                <label for="check9"></label>
              </div>
              <div className="mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <div style={datePickerStyle}>
                      <DatePicker
                        style={{ width: '120px !important' }}
                        label="From Date"
                        minDate={dayjs(new Date()).subtract(2, 'year')}
                        maxDate={
                          inverterviewbutton === 'custom'
                            ? technicalToDate
                            : dayjs()
                        }
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        value={technicalFromDate}
                        onChange={(value) => handleChooseDate(value, 'from')}
                        disabled={datepickerDisable}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className="mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <div style={datePickerStyle}>
                      <DatePicker
                        style={{ width: '120px !important' }}
                        label="To Date"
                        minDate={
                          inverterviewbutton === 'custom'
                            ? technicalFromDate
                            : dayjs(new Date()).subtract(2, 'year')
                        }
                        maxDate={dayjs()}
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        value={technicalToDate}
                        onChange={(value) => handleChooseDate(value, 'to')}
                        disabled={datepickerDisable}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>

              {openTable && (
                <div className="mr_8">
                  <VerticalAlignBottomIcon
                    className="i_clr pointer"
                    onClick={() => exportToCSV(mapInverterSeries)}
                  />
                </div>
              )}
              <div>
                <FullscreenIcon
                  className="i_clr pointer"
                  onClick={handleOpen}
                />
              </div>

              <Dialog fullScreen open={open} onClose={handleClose}>
                <IconButton
                  onClick={handleClose}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogTitle></DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    <div className="graph_bg">
                      <div className="align_btw mb_10">
                        <div>
                          <div className="h1">
                            Performance against Investor Guarantee Graph
                          </div>
                        </div>

                        <div className={classes.root}>
                          <div className="align_end">
                            <div class="check_graph mr_8">
                              <input
                                id="check9"
                                type="checkbox"
                                checked={openTable}
                                onChange={(e) => setOpenTable(!openTable)}
                              />
                              <label for="check9"></label>
                            </div>
                            <div className="mr_8">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    label="From Date"
                                    minDate={dayjs(new Date()).subtract(
                                      2,
                                      'year'
                                    )}
                                    maxDate={
                                      inverterviewbutton === 'custom'
                                        ? technicalToDate
                                        : dayjs()
                                    }
                                    format="DD-MM-YYYY"
                                    value={technicalFromDate}
                                    onChange={(value) =>
                                      handleChooseDate(value, 'from')
                                    }
                                    disabled={datepickerDisable}
                                  />
                                  {/* </div> */}
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>
                            <div className="mr_8">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    label="To Date"
                                    minDate={
                                      inverterviewbutton === 'custom'
                                        ? technicalFromDate
                                        : dayjs(new Date()).subtract(2, 'year')
                                    }
                                    maxDate={dayjs()}
                                    format="DD-MM-YYYY"
                                    value={technicalToDate}
                                    onChange={(value) =>
                                      handleChooseDate(value, 'to')
                                    }
                                    disabled={datepickerDisable}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>

                            {openTable && (
                              <div className="mr_8">
                                <VerticalAlignBottomIcon
                                  className="i_clr pointer"
                                  onClick={() =>
                                    exportToCSV(
                                      mapInverterSeries[0]?.data,
                                      columns
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="align_btw mb_">
                        <div
                          className=""
                          style={{
                            width: '50%',
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                        >
                          {/* <div> */}

                          <div
                            className="head_button mr_8"
                            style={
                              isButtonSelected(`ActualGeneration`)
                                ? {
                                    backgroundColor: 'rgba(89, 104, 183, 0.25)',
                                  }
                                : {}
                            }
                            onClick={() =>
                              handleButtonClick(`ActualGeneration`, '', 1)
                            }
                          >
                            Actual Generation
                          </div>
                          <div
                            className="head_button mr_8"
                            style={
                              isButtonSelected(`InvestorGuaranteedGeneration`)
                                ? {
                                    backgroundColor: 'rgba(89, 104, 183, 0.25)',
                                  }
                                : {}
                            }
                            onClick={() =>
                              handleButtonClick(
                                `InvestorGuaranteedGeneration`,
                                '',
                                1
                              )
                            }
                          >
                            Investor Guaranteed Generation
                          </div>

                          <div
                            className="head_button mr_8"
                            style={
                              isButtonSelected(`ForecastedGeneration`)
                                ? {
                                    backgroundColor: 'rgba(89, 104, 183, 0.25)',
                                  }
                                : {}
                            }
                            onClick={() =>
                              handleButtonClick(`ForecastedGeneration`, '', 1)
                            }
                          >
                            Forecasted Generation
                          </div>
                        </div>

                        <div>
                          <div
                            className={
                              inverterviewbutton === 'ytd'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('ytd')}
                          >
                            YTD
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'mtd'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('mtd')}
                          >
                            MTD
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'year'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('year')}
                          >
                            1 Y
                          </div>
                          <div
                            className={
                              inverterviewbutton === '6m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('6m')}
                          >
                            6 M
                          </div>
                          <div
                            className={
                              inverterviewbutton === '3m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('3m')}
                          >
                            3 M
                          </div>
                          <div
                            className={
                              inverterviewbutton === '1m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('1m')}
                          >
                            1 M
                          </div>
                        </div>
                      </div>
                      {openTable ? (
                        <div style={{ maxHeight: '360px', overflow: 'auto' }}>
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Date</TableCell>
                                  {dynamicHeadings?.map((heading, index) => (
                                    <TableCell key={index}>{heading}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {mapInverterSeries?.[0]?.data?.map(
                                  (row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                      <TableCell>
                                        {dayjs(row.x).format('DD-MM-YYYY')}
                                      </TableCell>
                                      {mapInverterSeries?.map((item, index) => (
                                        <TableCell key={index}>
                                          {item.data.find(
                                            (entry) => entry.x === row.x
                                          )?.y || 0}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      ) : (
                        <div>
                          <div>
                            <div
                              style={{
                                color: '#5968B7',
                                fontSize: '12px',
                                marginLeft: '5px',
                              }}
                            >
                              kWh
                            </div>
                          </div>
                          <div id="chart">
                            <ReactApexChart
                              options={lineData.options}
                              series={mapInverterSeries}
                              legend={lineData.legend}
                              type="line"
                              height={screenHeight - 200}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>

        <div className="align_btw mb_6">
          <Grid container>
            <Grid md={6}>
              <div className=" ">
                <div>
                  <div
                    className={`head_button`}
                    style={
                      isButtonSelected(`ActualGeneration`)
                        ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                        : {}
                    }
                    onClick={() => handleButtonClick(`ActualGeneration`, '', 1)}
                  >
                    Actual Generation
                  </div>
                  <div
                    className={`head_button`}
                    style={
                      isButtonSelected(`InvestorGuaranteedGeneration`)
                        ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                        : {}
                    }
                    onClick={() =>
                      handleButtonClick(`InvestorGuaranteedGeneration`, '', 1)
                    }
                  >
                    Investor Guaranteed Generation
                  </div>

                  <div
                    className={`head_button`}
                    style={
                      isButtonSelected(`ForecastedGeneration`)
                        ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                        : {}
                    }
                    onClick={() =>
                      handleButtonClick(`ForecastedGeneration`, '', 1)
                    }
                  >
                    Forecasted Generation
                  </div>
                </div>
              </div>
            </Grid>

            <Grid md={6} style={{ display: 'flex', justifyContent: 'end' }}>
              <div>
                <div
                  className={
                    inverterviewbutton === 'custom'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('custom')}
                >
                  CUST
                </div>
                <div
                  className={
                    inverterviewbutton === 'ytd'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('ytd')}
                >
                  YTD
                </div>
                <div
                  className={
                    inverterviewbutton === 'mtd'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('mtd')}
                >
                  MTD
                </div>
                <div
                  className={
                    inverterviewbutton === 'year'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('year')}
                >
                  1 Y
                </div>
                <div
                  className={
                    inverterviewbutton === '6m'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('6m')}
                >
                  6 M
                </div>
                <div
                  className={
                    inverterviewbutton === '3m'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('3m')}
                >
                  3 M
                </div>
                <div
                  className={
                    inverterviewbutton === '1m'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('1m')}
                >
                  1 M
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {openTable ? (
          <div style={{ maxHeight: '360px', overflow: 'auto' }}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>

                    {dynamicHeadings?.map((heading, index) => (
                      <TableCell key={index}>{heading}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mapInverterSeries?.[0]?.data?.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell>{dayjs(row.x).format('DD-MM-YYYY')}</TableCell>
                      {mapInverterSeries?.map((item, index) => (
                        <TableCell key={index}>
                          {item.data.find((entry) => entry.x === row.x)?.y || 0}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : (
          <div>
            <div>
              <div
                style={{
                  color: '#5968B7',
                  fontSize: '12px',
                  marginLeft: '5px',
                }}
              >
                kWh
              </div>
            </div>
            <div id="chart">
              <ReactApexChart
                options={lineData.options}
                series={mapInverterSeries}
                legend={lineData.legend}
                type="line"
                height={350}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

InvestorGuaranteedgraph.propTypes = {}

export default InvestorGuaranteedgraph
